module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/chevron-carousel-mobile-b13331e34a593d6ac321bbe22112b487.svg";